import React from 'react';
import { trackContentLinkClick } from '../atlas-link/track';
import type { ContentLinkAnalytics } from '../atlas-link/track';
import { useContentLinkViewedAnalytics } from '../../hooks/use-content-link-viewed-analytics';

export const LinkExtension = ({
    href,
    label,
    shouldPreventRedirect,
    contentLinkAnalytics
}: {
    href: string;
    label: string;
    shouldPreventRedirect: boolean;
    contentLinkAnalytics: ContentLinkAnalytics;
}) => {
    // Automatically track viewed event.
    // LinkExtension handles both the "viewed" (render) and "clicked" (interaction) analytics events.
    // extension-handlers always provides contentLinkAnalytics (either with payload or shouldSkip: true).
    useContentLinkViewedAnalytics(contentLinkAnalytics);
    return (
        <a
            href={href}
            data-testid="sac-link-extension"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
                // Track clicked event
                trackContentLinkClick({ href, contentLinkAnalytics });
                if (shouldPreventRedirect) {
                    e.preventDefault();
                }
            }}
        >
            {label}
        </a>
    );
};
